/**
 * @param {import("@seabrookstudios/pitch2table-core").EULAVersion} latestVersion
 * @param {import("@seabrookstudios/pitch2table-core").EULAVersion} acceptedVersion
 * @returns {boolean}
 */
export const isEulaRequired = (latestVersion, acceptedVersion) => {
  if (!latestVersion) {
    return false;
  }

  return acceptedVersion !== latestVersion;
};
